<template>
  <div class="config_main_manage_page_wraper config_action_list">
    <div class="config_main_manage_page_content">
      <config-title-hang>
        <span slot="config_title_hang_ele2">{{ productTitle }}</span>
      </config-title-hang>

      <config-hang v-for="item in configList" :key="item.itemKey"
        :button-hang-ele5-completed="Boolean(completedItems[item.itemKey])">
        <span slot="config_hang_ele2_1">{{ item.title }}</span>
        <span slot="config_hang_ele2_2">{{ item.description }}</span>
        <span slot="config_button_hang_ele5" @click.stop="resendConfig(item)">
          {{ configButtonText(item) }}
        </span>
      </config-hang>

      <div v-if="!loading && configList.length === 0" class="xiaotishi_style">
        当前产品没有可补发的配置数据。
      </div>
      <div v-if="isPanelExtension" class="xiaotishi_style">
        提示：当前为面板扩展产品，需进入扩展面板管理页面完成所有面板上线，随后，再回到本页面完成子面板按键配置项补发。
      </div>
      <div v-if="configList.length > 0" class="xiaotishi_style">
        提示：每次仅补发当前行配置，成功后可继续补发其他配置。
      </div>
    </div>
  </div>
</template>

<script>
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'

export default {
  components: { configHang, configTitleHang },
  data() {
    return {
      loading: false,
      loadingId: '',
      configList: [],
      // 仅在当前页面生命周期内记录成功项，离开或刷新页面后自动清除。
      completedItems: {}
    }
  },
  computed: {
    productTitle() {
      return (this.$route.query.productName || this.$route.query.remark || '当前产品') + '配置数据补发'
    },
    isPanelExtension() {
      return this.$route.query.productCode === '100' && Number(this.$route.query.productSource) === 1
    }
  },
  created() {
    this.loadConfigList()
  },
  methods: {
    loadConfigList() {
      this.loading = true
      this.$request({
        method: 'post',
        url: '/product/findProductResendConfigList',
        data: { token: this.$store.state.token, productId: this.$route.query.productId }
      }).then(res => {
        if (res.data.code !== 0) {
          this.$showTipsToast(3, res.data.message)
          return
        }
        this.configList = res.data.data || []
      }).catch(error => console.log(error)).finally(() => {
        this.loading = false
      })
    },
    resendConfig(item) {
      if (this.loadingId || this.completedItems[item.itemKey]) return
      this.loadingId = item.itemKey
      this.$request({
        method: 'post',
        url: '/product/resendProductConfigItem',
        timeout: item.configType === 'BRAND_BC' ? 60000 : undefined,
        data: {
          token: this.$store.state.token,
          productId: this.$route.query.productId,
          itemKey: item.itemKey
        }
      }).then(res => {
        if (res.data.code !== 0) {
          this.$showTipsToast(3, res.data.message)
          return
        }
        this.$set(this.completedItems, item.itemKey, true)
        this.$showTipsToast(1, item.title + '补发成功', true)
      }).catch(error => console.log(error)).finally(() => {
        this.loadingId = ''
      })
    },
    configButtonText(item) {
      if (this.loadingId === item.itemKey) return '补发中'
      return this.completedItems[item.itemKey] ? '已完成' : '补发'
    }
  }
}
</script>
